import "./styles.sass";
import { useApi } from "../../hooks/use-api";
import { useState, useEffect } from "react";
import { apiHostHistory } from "../../utils/api-routes";
import assets from "../../assets";

export const AdminQuizHistory = ({ resetQuizFlow }) => {
  const { get } = useApi();
  const [typeFilter, setTypeFilter] = useState("all");

  const [sortOrder, setSortOrder] = useState("recent");

  const formatDateTime = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const [history, setHistory] = useState([]);

  useEffect(() => {
    getHistory();
  }, []);

  const getHistory = async () => {
    try {
      const mail = "fanamdigitalai@gmail.com";

      const res = await get(apiHostHistory(mail));

      console.log(res, "history response");

      setHistory(res?.data);
    } catch (e) {
      console.log("Error on getting history", e);
    }
  };

  const filteredHistory = history?.sessions
    ?.filter((item) => {
      if (typeFilter === "all") {
        return true;
      }

      return item?.mode?.toLowerCase() === typeFilter.toLowerCase();
    })
    ?.sort((a, b) => {
      const dateA = new Date(a?.ended_at || a?.created_at);

      const dateB = new Date(b?.ended_at || b?.created_at);

      if (sortOrder === "recent") {
        return dateB - dateA;
      }

      return dateA - dateB;
    });

  return (
    <section className="history-container">
      <section className="top-bar">
        <span className="back" onClick={resetQuizFlow}>
          <img src={assets.ic_arrow_back} alt="" />
          Back to Main Menu
        </span>
      </section>
      <section className="history-page">
        <section className="history-review">
          <section>
            <h2>Quiz History</h2>
            <p className="subtitle-review">
              Review your past performance and track your learning progress.
            </p>
          </section>

          {/* FILTERS */}
          <section className="filters">
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
            >
              <option value="all">All Types</option>

              <option value="live">Live</option>

              <option value="async">Async</option>
            </select>
            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            >
              <option value="recent">Recent First</option>

              <option value="oldest">Oldest First</option>
            </select>
          </section>
        </section>
        {/* LIST */}
        <section className="history-list">
          {filteredHistory?.map((item) => (
            <section className="history-card" key={item.room_code}>
              <section className="history-left">
                <section className="top">
                  <span className="id">{item.room_code}</span>
                  <span className={`mode-badge  ${item.mode}`}>
                    {/* <img
                      src={
                        item.mode === "async" ? assets.ic_async : assets.ic_live
                      }
                      alt=""
                    /> */}
                    {item.mode}
                  </span>
                </section>

                <h4>{item.filters?.chapter || item.filters?.lesson}</h4>

                <section className="meta">
                  <span>{`Class ${item?.filters?.clas}`}</span>
                  <span>{formatDateTime(item?.ended_at)}</span>
                </section>
              </section>

              <section className="right">
                <h3>
                  {item?.top_players?.length
                    ? item?.top_players[0]?.score
                    : "-"}{" "}
                  <span>pts</span>
                </h3>
                <p>Rank {item.rank}</p>
              </section>
            </section>
          ))}
        </section>
      </section>
    </section>
  );
};
